/**
 * Hatcheries have no logos, so the directory gives each one a stable coloured
 * monogram — the same hatchery is always the same colour, which is what makes a
 * list of names scannable on a phone.
 */
const PALETTE = [
  { bg: '#0d6e70', fg: '#ffffff' }, // brand teal
  { bg: '#e2562f', fg: '#ffffff' }, // shrimp coral
  { bg: '#1f6fa8', fg: '#ffffff' }, // deep blue
  { bg: '#0f7a52', fg: '#ffffff' }, // green
  { bg: '#8a4fbd', fg: '#ffffff' }, // violet
  { bg: '#b8600d', fg: '#ffffff' }, // amber
  { bg: '#c0356c', fg: '#ffffff' }, // magenta
  { bg: '#3d5a80', fg: '#ffffff' } //  slate
]

/** Up to two initials: "Bayfront Aqua Hatcheries" -> "BA". */
export function initials (name = '') {
  const words = String(name)
    .replace(/[^A-Za-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
  if (!words.length) return '?'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[1][0]).toUpperCase()
}

export function monogramColor (key = '') {
  let hash = 0
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length]
}

export function monogram (name, key = name) {
  return { text: initials(name), ...monogramColor(String(key)) }
}
